import { ReactNode } from "react";
import { Toaster } from "react-hot-toast";
import { toastMessage } from "../helpers/toast/toastMessage";
import { palette, sp } from "../styles/design-tokens";

interface ToastProviderProps {
  children: ReactNode;
}

const ToastProvider = ({ children }: ToastProviderProps) => (
  <>
    <Toaster
      position="top-center"
      reverseOrder={false}
      containerStyle={{ maxWidth: "100vw", padding: sp(0, 16) }}
      // Theme Studio app colours; the fallbacks are react-hot-toast's own white / dark grey.
      toastOptions={{
        style: { maxWidth: "calc(100vw - 32px)", background: `var(--zv-surface, ${palette["White"]})`, color: `var(--zv-text-primary, ${palette["gray-21"]})` },
      }}
    />
    {children}
  </>
);

export { ToastProvider, toastMessage };
